import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Trans, t } from '@lingui/macro';
import Isvg from 'react-inlinesvg';
import '../../styles/core.scss';
import css from './filter.scss';

import {
    yearGroupSelected,
    itemTypeSelected,
    itemCategorySelected,
    clearSelection,
    filterLibraryItems,
    fetchCountrySpec
} from './filter-actions';

import CheckBoxGroup from '../../components/check-box-group/check-box-group';
import Button from '../../components/button/button';
import { Cross } from '../../helpers/icon-dictionary';

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = { valueAttr: '' };
    }

    static propTypes = {
        yearGroupSelected: PropTypes.func,
        itemTypeSelected: PropTypes.func,
        itemCategorySelected: PropTypes.func,
        clearSelection: PropTypes.func,
        filterLibraryItems: PropTypes.func,
        filterReducer: PropTypes.object,
        fetchCountrySpec: PropTypes.func,
        hasError: PropTypes.bool,
        isLoading: PropTypes.bool,
        clearButtonDisabled: PropTypes.bool,
        goButtonDisabled: PropTypes.bool,
        i18n: PropTypes.object
    };

    componentDidMount() {
        this.props.fetchCountrySpec();
    }

    handleOnSearchTextBoxChanged = (e) => {
        this.setState({ valueAttr: e.target.value });
    };

    handleOnGo = () => {
        this.props.filterLibraryItems(this.state.valueAttr);
    };

    handleOnSearchClear = () => {
        this.setState({ valueAttr: '' });
    };

    handleOnClearSelection = () => {
        this.setState({ valueAttr: '' });
        this.props.clearSelection();
    };

    handleYearGroupSelected = (payload) => {
        this.props.yearGroupSelected(payload);
    };

    handleItemCategorySelected = (payload) => {
        this.props.itemCategorySelected(payload);
    };

    handleItemTypeSelected = (payload) => {
        this.props.itemTypeSelected(payload);
    };

    render() {
        const { i18n } = this.props.i18n;
        const itemTypes = this.props.filterReducer.itemTypes || [];

        if (this.props.hasError) {
            return <p><Trans>Sorry! There was an error loading the country spec</Trans>.</p>;
        }

        if (this.props.isLoading) {
            return <p><Trans>Loading</Trans>.....</p>;
        }


        return (
            <div className={css.component}>
                <h3><Trans>Filter for eBooks</Trans></h3>
                <div className={css.filterRow1}>
                    <CheckBoxGroup
                        label={<Trans>Grades</Trans>}
                        values={this.props.filterReducer.yearGroups}
                        callbackOnChange={this.handleYearGroupSelected}
                        className={css.grades} />
                    <div className={css.filterRow2}>


                        <CheckBoxGroup
                            label={<Trans>Book</Trans>}
                            values={this.props.filterReducer.itemCategories}
                            callbackOnChange={this.handleItemCategorySelected}
                            className={css.category} />
                        { itemTypes.length > 1 &&
                        <CheckBoxGroup
                            label={<Trans>Book type</Trans>}
                            values={this.props.filterReducer.itemTypes}
                            callbackOnChange={this.handleItemTypeSelected}
                            className={css.bookType} />
                        }
                        <div key="button" className={css.panel}>
                            <div className={css.searchContainer}>
                                <input
                                className={css.textBoxSearchText}
                                onChange={this.handleOnSearchTextBoxChanged}
                                type="text"
                                value={this.state.valueAttr} />
                                <div>
                                    <div
                                        className={css.searchClearContainer}
                                        tabIndex={0}
                                        role="button"
                                        onClick={this.handleOnSearchClear}
                                    ><Isvg src={Cross} /></div>
                                </div>
                            </div>

                            <div className={css.buttonContainer}><Button
                                label={i18n._(t`Clear`)}
                                className={css.clear}
                                disabled={this.props.clearButtonDisabled}
                                callbackOnClick={this.handleOnClearSelection} />&nbsp;

                                <Button
                                    label={i18n._(t`GO`)}
                                    className={css.go}
                                    disabled={this.props.goButtonDisabled}
                                    callbackOnClick={this.handleOnGo} /></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        filterReducer: state.filterReducer,
        isLoading: state.countrySpecLoading,
        hasError: state.countrySpecLoadFailed
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        yearGroupSelected,
        clearSelection,
        filterLibraryItems,
        itemCategorySelected,
        itemTypeSelected,
        fetchCountrySpec
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Filter);
